import { render, staticRenderFns } from "./DiseaseFilters.vue?vue&type=template&id=5b215688&"
import script from "./DiseaseFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DiseaseFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b215688')) {
      api.createRecord('5b215688', component.options)
    } else {
      api.reload('5b215688', component.options)
    }
    module.hot.accept("./DiseaseFilters.vue?vue&type=template&id=5b215688&", function () {
      api.rerender('5b215688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DiseaseFilters/DiseaseFilters.vue"
export default component.exports